import script from "./DowngradeConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./DowngradeConfirm.vue?vue&type=script&setup=true&lang=js"

import "./DowngradeConfirm.vue?vue&type=style&index=0&id=9ea3ae08&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ea3ae08"]])

export default __exports__